module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[45]166.1dcdf9d.woff2";